module.exports = function () {
    $('body').on('click', '.backstage-add-premium-to-cart', function (e) {
        e.preventDefault();

        // Serialize form, grab AJAX URL
        var url = window.CachedData.premiumSignupSubmit;

        // Make AJAX call
        $.ajax({
            url: url,
            success: function (data) {
                if (data.successMessage) {
                    successModal(data.redirectUrl);
                } else if (data.success) {
                    if (window.CachedData?.flyoutFlyoutCreateAccountUrl && data.redirectUrl.startsWith(window.CachedData.flyoutLoginShowUrl)) {
                        $('#backstage-modal').modal('hide');
                        $('body').trigger('initFlyout', {
                            url: window.CachedData.flyoutFlyoutCreateAccountUrl,
                        });
                    } else {
                        window.location = data.redirectUrl;
                    }
                } else {
                    console.log(data.errors);
                }
            }
        });
    });
};

function successModal(redirectUrl) {
    $('#backstage-modal .success-message').removeClass('d-none');
    $('#backstage-modal .survey-content').html('');
    $('#backstage-modal').on('hidden.bs.modal', function () {
        if (redirectUrl) {
            window.location = redirectUrl;
        }
    });
}

